module.exports = __webpack_public_path__ + "static/media/icon-master.20c86c01.png";